/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandDouban = createReactComponent("outline", "brand-douban", "IconBrandDouban", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M5 4h14", "key": "svg-1" }], ["path", { "d": "M8 8h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2z", "key": "svg-2" }], ["path", { "d": "M16 14l-2 6", "key": "svg-3" }], ["path", { "d": "M8 17l1 3", "key": "svg-4" }]]);

export { IconBrandDouban as default };
//# sourceMappingURL=IconBrandDouban.mjs.map
